<template>
<div>  
    
 <div class="over"   >
     
  <table id="notasCom" v-if=" this.$store.state.tipoNota == 'NFe'">
    <tr>
        <th v-show="emitidas != false || $route.name == 'baixar' "> <input type="checkbox" @click="GetAllInput()" :checked="getInput" style="margin-top: 10px;"></th>
        <th style="font-weight:300;" v-show="$route.name != 'baixar' & emitidas != false">Manifestar seleção</th> 
        <th>Chave de acesso</th>
        <th>DANFE</th>
        <th>Número</th>
        <th>Empresa</th>
        <th>CNPJ</th>
        <th>Valor</th>
        <th style="text-align:center">Situação</th>
        
        <th>Emissão</th>
        <th>Origem</th>
        <th>Tipo</th>
    </tr>
    <tr v-for="(n,i) in notasq" :key="i" style="height:38px;">
        <td v-show=" emitidas != false || $route.name == 'baixar'">
            <input type="checkbox" @click="OneInput(n)" :checked="n.checked" class="allIn" :value="n.chaveAcesso" style="margin-top: 10px;" :disabled="n.situacao == 'Cancelada'">
        </td>
        <td v-show="$route.name != 'baixar' & emitidas != false">
            <div class="ajusBol">
                <div :class="[{bolinha:true},n.manifestacao]">
                </div>
                <div style="position:relative;">
                <div :class="{bolinhas:true,coloca:i ==coloca}" >
                    <div style="display: flex; justify-content: flex-end; padding:5px;">
                    <img src="/arqlef/mais2.svg" width="15px" class="allAbl" style="top: 14px;cursor:pointer;transform: rotate(45deg);" @click="fehcarBol(n.chaveAcesso)">
                        </div>
                    <div class="a" style="background: #E5F4F3;" @click="Emitir('210210',n.chaveAcesso)">
                        <div class="bolinha" style="background:green;">

                        </div>
                        <span>Ciência da Emissão</span>
                    </div>
                     <div class="a" @click="Emitir('210200',n.chaveAcesso)">
                        <div class="bolinha" style="background:#899D01;" >

                        </div>
                        <span>Confirmar Operação</span>
                    </div>
                     <div class="a" style="background: #E5F4F3;" @click="Emitir('210240',n.chaveAcesso)">
                        <div class="bolinha" style="background:#E8FF00;">

                        </div>
                        <span>Operação não realizada</span>
                    </div>
                     <div class="a"  @click="Emitir('210220',n.chaveAcesso)">
                        <div class="bolinha" style="background:#9D0101;">

                        </div>
                        <span>Desconhecimento</span>
                    </div>                     
                </div>
                </div>
                <span class="triangulo" @click="exibirOp(i,n)" :style="{'cursor':n.situacao  == 'Cancelada'?'inherit': 'pointer'}">
                       
                </span>
                
            </div>
        </td>
        <td>{{n.chaveAcesso}}</td>
        <td>
            <div  v-if="n.situacao  != 'Cancelada' &  n.documentoDisponivel != false" class="exibirOpN" >
                <div :class="{ex:true,coloca1:i ==coloca1}">
                    <p @click="irParaNfeCompleta(n.chaveAcesso)">Nota Completa</p>
                    <p  @click="verDanfe(n.situacao,n.documentoDisponivel,n.chaveAcesso)" style="background: rgb(229, 244, 243);">Ver DANFE</p>
                </div>
                <img src="/arqlef/caminho.svg" style="cursor:pointer;"  @click="exibirNf(i)">
            </div>
            <div v-else>
                <img  src="/arqlef/caminhoIndis.svg" style="background: #ccc, cursor: inherit" alt="" @click="verDanfe(n.situacao,n.documentoDisponivel,n.chaveAcesso)">
            </div>
        </td>
        <td>
            {{n.numero}}
        </td>
        <td style="text-align:left;">
            {{n.empresa}}
        </td>
        <td>
            {{n.cnpj}}
        </td>
        <td>
            {{n._valor}}
        </td>
        <td>
            <img src="/arqlef/img/refresh.svg" alt=""  width="20" style="margin-right:7px;cursor:pointer" @click="abrirModalStatus(n.situacao,n.chaveAcesso)" v-if="n.situacao != 'Cancelada' "/>
            <img src="/arqlef/img/refresInativo.svg" alt=""  width="20" style="margin-right:7px;cursor:pointer" @click="abrirModalStatus(n.situacao,n.chaveAcesso)" v-else/>

            <span style="margin-right:10px">{{n.situacao}}</span>
            
        </td>
        <td>
            {{n.dataEmissao}}
        </td>
        <td>
            {{n.origem}}
        </td>
        <td>
            {{n.tipoOperacao}}
        </td>
    </tr>
  </table>
  <table id="notasCom" v-else-if=" this.$store.state.tipoNota == 'NFCe'">
    <tr>
        
       
        <th>Chave de acesso</th>       
        <th>Número</th>
        <th>DANFE</th>
        <th>Empresa</th>
        <th>CNPJ</th>
        <th>Valor</th>     
        <th>IE</th>  
        <th>Emissão</th>
        <th>UF Destino</th>
        <th>UF Origem</th>
        <th>Tipo</th>
    </tr>
    <tr v-for="(n,i) in notasq" :key="i" style="height:38px;">
               
        <td>{{n.chaveAcesso}}</td>       
        <td>
            {{n.numero}}
        </td>
        <td>
            <img  src="/arqlef/caminho.svg" style="background: #ccc, cursor: inherit" alt="" @click="abrirNfe(n.chaveAcesso)">
        </td>
        <td style="text-align:left;">
            {{n.empresa}}
        </td>
        <td>
            {{n.documento}}
        </td>
        <td>
            {{n.valor}}
        </td>  
        <td>
            {{n.ie}}
        </td>      
        <td>
            {{n.dataEmissao}}
        </td>
        <td>
            {{n.ufDestino}}
        </td>
        <td>
            {{n.ufOrigem}}
        </td>
        <td>
            {{n.tipoOperacao}}
        </td>
    </tr>
  </table>
  <table id="notasCom" v-else>
     <tr>
        <th v-show="$route.name == 'baixar' "> <input type="checkbox" @click="GetAllInput()" :checked="getInput" style="margin-top: 10px;"></th>
        <th>Chave de Acesso</th>
        <th>Numero</th>        
        <th>Emissão</th>
        <th>Tipo</th>
        <th>Valor</th>
        <!--<th>Status</th> -->
        <th>Relação</th>        
        
        <th>Emitente</th>
        <th>CPF/CNPJ Emitente</th>
        <th>IE Emitente</th>
        <th>Remetente</th>
        <th>CPF/CNPJ Remetente</th>
        <th>IE Remetente</th>
        <th>Expedidor</th>
        <th>CPF/CNPJ Expedidor</th>
        <th>IE Expedidor</th>
        <th>Recebedor</th>
        <th>CPF/CNPJ Recebedor</th>
        <th>IE Recebdor</th>
        <th>Destinatário</th>
        <th>IE Destinatário</th>
        <th>CPF/CNPJ Destinatário</th>
        <th>Tomador</th>
        <th>IE Tomador</th>
        <th>CPF/CNPJ Tomador</th>
        <th>Origem</th>              
    </tr>
    <tr v-for="(n,i) in notasq" :key="i" style="height:38px;">     
        <td v-show="$route.name == 'baixar'">
            <input type="checkbox" @click="OneInput(n)" :checked="n.checked" class="allIn" :value="n.chaveAcesso" style="margin-top: 10px;">
        </td>
        <td>
            {{n.chaveAcesso}}
        </td>
        <td>
            {{n.numero}}
        </td>        
        <td>
            {{n.dataEmissao}}
        </td>
        <td>
            {{n.tipo}}
        </td>
        <td  >
            {{n._valor}}
        </td>
       <!-- <td>
            {{n.status}}
        </td>-->
        <td >
            {{n.relacao}}
        </td>       
       
        <td >
            {{n.emitente.nome}}
        </td>
        <td  >
            {{n.emitente.documento}}
        </td>
        <td  >
            {{n.emitente.ie}}
        </td>
        <td>
            {{n.remetente.nome}}
        </td>
        <td>
            {{n.remetente.documento}}
        </td>
        <td>
            {{n.remetente.ie}}
        </td>
        <td>
            {{n.remetente.nome}}
        </td>
        <td>
            {{n.remetente.documento}}
        </td>
        <td>
            {{n.remetente.ie}}
        </td>
        <td>
            {{n.recebedor.nome}}
        </td>
        <td>
            {{n.recebedor.documento}}
        </td>
        <td>
            {{n.recebedor.ie}}
        </td> 
        <td>{{n.destinatario.nome}}</td>
        <td>
            {{n.destinatario.ie}}
        </td>
        <td>
            {{n.destinatario.documento}}
        </td>
         <td>
            {{n.tomador.nome}}
        </td>        
        <td>
            {{n.tomador.ie}}
        </td>
        <td>{{n.tomador.documento}}</td>
        <td>
            {{n.origem}}
        </td>       
    </tr>
  </table>
  <b-modal ref="modalStatusNfe"  id="modalStatusNfe" hide-footer size="lg" title="NF-e Atualizada" @hide="doSometing">  
    <div v-if="!erroStatus">
        <table>
            <tr style="  
    border-bottom: 1px solid #dee2e6;">
                <td style="    padding: 2px;
    padding-bottom: 20px;">
                    <b>Data Consulta: </b>
                </td>
                <td style="    padding: 2px;
    padding-bottom: 20px;">
                    {{statusDataConsulta}}
                </td>
            </tr>
            <tr>
                <td style="padding:2px">
                   <b>Número: </b>
                </td>
                <td style="padding:2px">
                    {{statusNumero}}
                </td>
            </tr>
            <tr>
                <td style="padding:2px">
                   <b>Chave de Acesso: </b>
                </td>
                <td style="padding:2px">
                    {{statusChaveAcesso}}
                </td>
            </tr>
            <tr>
                <td style="padding:2px">
                   <b>Valor: </b>
                </td>
                <td style="padding:2px">
                    {{statusValor}}
                </td>
            </tr>
            <tr>
                <td style="padding:2px">
                    <b>Manifestação: </b>
                </td>
                <td style="padding:2px"> 
                    {{statusManifestacao}}
                </td>
            </tr>
            <tr>
                <td style="padding:2px">
                  <b> Situação: </b> 
                </td>
                <td style="padding:2px"> 
                    {{statusSituacao}}
                </td>
            </tr>
        </table>
        
    </div>
    <div v-else>
        <div v-if="erroStatusTxt==''">
            <div class="d-flex justify-content-center mb-3">
                    <b-spinner label="Loading..."></b-spinner>
                </div>

        </div>
        <div v-else>
            <p style="text-align:center">{{erroStatusTxt}}</p>
        </div>
        
    </div>  
    
  </b-modal>
  <b-modal ref="danfe" hide-footer >
      <p style="color: #707070;font-weight: 600;text-align:center;font-size:18px;">Não foi possivel gerar o DANFE</p>
  </b-modal>
  <b-modal id="modalEmitir"  ref="modalEmitir" size="lg">
      <p v-show="msgEmicao" style="color: #707070;font-weight: 600;">{{msgEmicao}}</p>
      <p  style="color: rgb(112, 112, 112);    font-weight: 600; margin-top:15px; margin-bottom: 0px;  font-size: 18px;">Total de notas para manifestar: <span style="color:green;">{{quantEmisao}}</span></p>
       <tableStatusEmitir :tableNotas="tableNotas" :exibitable="exibitable" /> 
      <div style="display:flex; align-items: center; justify-content: center;" >
        <div  v-if="!exibitable" v-show="quantEmisao" @click="manifestar()" style="width: 150px;  cursor:pointer; margin-bottom:15px;  padding: 10px;color: #fff;background: #009188;    text-align: center;    border-radius: 5px;">
            <span v-if="spinerManifestar" style="color:#fff">
                <b-spinner label="Loading..."></b-spinner>
            </span>
            <span v-else>Manifestar</span>
        </div>
      </div>
      <b-popover target="popover-target-1" triggers="hover" placement="top">
            
            <img src="https://www.lefisc.com.br/arqlef/img/prazos_manifestacao.png" alt="" width="100%">
        
    
  </b-popover>
      <p style="margin-bottom: 0px;margin-top:10px">Prazos para apresentação de manifestação: <img   id="popover-target-1" style="transform: rotate(181deg);" src="/arqlef/img/sa.svg" alt="" width="18px" ></p>
  </b-modal>
  <vue-topprogress ref="topProgress"></vue-topprogress>
  </div>  
  </div>
</template>

<script>
import barramento from '../services/barramento'
import tableStatusEmitir from '../components/tableStatusEmitir'
import config from '../services/config'
import { vueTopprogress } from "vue-top-progress";
export default {
    components:{vueTopprogress,tableStatusEmitir},
    props:['notasq','existeNota','emitidas'],
    data(){
        return{
            erroStatus:true,
            erroStatusTxt:'',
            nAntes:{},
            exibitable:false,
            tableNotas:[],
            infoStatus:[],
            nomeRota:'',
            getInput:false,           
            notasSelecionadas:[],
            coloca:null,
            msgEmicao:'',
            danfe:true,
            quantEmisao:0,
            spinerManifestar:false,
            valueMani:'',
            arraySetEnvio:{},
            clickManifestar:false,
            coloca1:null,
            statusNumero:'',
            statusChaveAcesso:'',
            statusValor:'',
            statusDataConsulta:'',
            statusManifestacao:'',
            statusSituacao:''
        }
    },
    computed:{       
    },
    methods:{
        async abrirNfe(chaveAcesso){
            
            this.$refs.topProgress.start();
            window.open(
                    "https://www.lefisc.com.br/api/arqlef/nfce/gerarDANFE/" +
                        this.$store.state.idEmpresa +
                        "/" +
                        chaveAcesso 
                        ,
                    "_blank"
                    );
                
                this.$refs.topProgress.done();
        },
        async abrirModalStatus(situacao,chaveAcesso){    
            
            if(situacao != 'Cancelada')    {
                this.erroStatusTxt = ''    
                this.$refs["modalStatusNfe"].show();
                await config.statusNfe(this.$store.state.idEmpresa,chaveAcesso)
                .then(e=>{
                    if(e.status <= 204){
                      
                        this.statusNumero = e.data.dadosNFe.numero
                        this.statusChaveAcesso = e.data.dadosNFe.chaveAcesso
                        this.statusValor = e.data.dadosNFe.valor
                        this.statusManifestacao = e.data.dadosNFe.manifestacao
                        this.statusSituacao = e.data.dadosNFe.situacao
                        this.statusDataConsulta = e.data.dataConsulta
                        this.infoStatus = e.data
                        this.erroStatus = false
                       
                    }else{
                        this.erroStatus = true
                        this.erroStatusTxt = e.data.message
                    }   
                })
            }
        },
        OneInput(n){
            if(n.checked){
                n.checked = false

            }else{
                n.checked = true
            } 
            this.notasSelecionadas.push(n)  
            let semFalse = this.notasSelecionadas.filter(p=>p.checked != false)  
            barramento.$emit('pegarSelecionadas',new Set(semFalse))  
        },
        GetAllInput(){
            this.getInput = !this.getInput            
            if(this.getInput){   
                this.notasq.forEach(element => {
                    if(element.situacao != 'Cancelada')
                        element.checked = true
                        this.notasSelecionadas.push(element)
                });  
            }else{
               this.notasSelecionadas.forEach(element => { 
                   element.checked = false
                });  
                this.notasSelecionadas = []
            }
            barramento.$emit('pegarSelecionadas',new Set(this.notasSelecionadas))
        },
        async manifestar(){
            if(this.spinerManifestar == false){
                this.clickManifestar = true
                barramento.$emit('clickMani', this.clickManifestar)
                this.spinerManifestar = true                 
                let res = await config.manifestar(this.$store.state.idEmpresa,this.arraySetEnvio)
                if(res.status <=205){                  
                     this.exibitable = true
                    this.tableNotas = res.data.lstErros
                }
                this.notasSelecionadas.forEach(element => { 
                   element.checked = false
                });  
                this.coloca =  null
                this.notasSelecionadas = []
                this.spinerManifestar = false
            }
        },
        montarListaEnvio(set){
            let array = {"evento":this.valueMani, "chaves":[]}          
            set.forEach(function(value) {
                array.chaves.push(value.chaveAcesso)
            });
            this.arraySetEnvio = array
        },
        async verDanfe(situacao, documentoDisponivel, chaveAcesso) {
            if (situacao != "Cancelada" && documentoDisponivel != false) {
                if (this.danfe) {
                this.danfe = false;
                this.$refs.topProgress.start();
                let status = await config.danfe(
                    this.$store.state.idEmpresa,
                    chaveAcesso
                );
                if (status.status >= 400) {
                    this.$refs["danfe"].show();
                } else
                    window.open(
                    "https://www.lefisc.com.br/api/arqlef/nfe/downloadDANFE/" +
                        this.$store.state.idEmpresa +
                        "/" +
                        chaveAcesso +
                        "/5f900aa22283470900174caed0f8a148",
                    "_blank"
                    );
                }
                this.$refs.topProgress.done();
                this.danfe = true;
            }
        },
        async Emitir(value,i){
            this.valueMani = value
            this.msgEmicao = ''
            this.exibitable = false
            this.$refs['modalEmitir'].show()
            let semFalse = this.notasSelecionadas.filter(p=>p.checked != false)
            let set = new Set(semFalse)
            this.quantEmisao = set.size
            if(set.size == 0){
                this.quantEmisao = 1
                this.arraySetEnvio = {"evento":this.valueMani, "chaves":[i]} 
               console.log(i)     
            }else{
                this.montarListaEnvio(set)
            }
        },
        exibirOp(ia,n){           
            if(n.situacao  != 'Cancelada'){
                this.coloca = ia 
            }     
        },
        exibirNf(ia){
            if(this.coloca1 == ia){
                this.coloca1 = null
            }else{
                this.coloca1 = ia
            }
        },
        fehcarBol(){
            this.coloca =  null
        },   
        irParaNfeCompleta(c){           
            let d = c    
            this.$store.state.chave = d       
        let jsonAux = JSON.stringify({"razaoSocial":this.$store.state.razaoSocial,"idEmpresa":this.$store.state.idEmpresa,"chave":d});
          sessionStorage.setItem('objCli',jsonAux);
           
            this.$router.push({
                name:'notacompleta'
                })
        }    ,
        doSometing(){
            barramento.$emit('sairStatus','valor')
        } 
    },
    mounted(){
        
        barramento.$on('clickStatus', valor=>{
            if(valor){
                this.clickManifestar = false
            }else{
                this.clickManifestar = true
            }
         }) 
        barramento.$on('getInputMudou', valor => {
            this.getInput = valor
            this.notasSelecionadas = []
        })
       
    },   

}
</script>

<style>
.popover-body{
    word-break: normal !important;
   
}
.popover{
    word-break: normal !important;
    
}
.popover{
    max-width: 100%; /* Max Width of the popover (depending on the container!) */
}
.exibirOpN{
    position: relative;
    cursor: pointer;
}
.exibirOpN .ex{
    position: absolute;
    display: none;
    top:10px;
    left: 34px;
    background: #fff;
    box-shadow: 0px 6px 6px #00000029;
}
.exibirOpN .ex p{
    margin-bottom: 0px;
    padding:10px;
    text-align: center;
    color:#000;
    font-weight: 500;
}
table th {   
    position: sticky;
    top: 0;
    z-index: 10; 
    background: #fff;
}
div.Ciencia{
    background: green; 
}
div.Confirmada{
    background: rgb(137, 157, 1); 
}
div.Desconhecida{
    background: rgb(157, 1, 1);
}
div.Cancelada{
    background: rgb(232, 255, 0); 
}
div.coloca{
    display: block ;
}
.exibirOpN  div.coloca1{
    display: block ;
}
.over{
    position: relative;
    overflow: auto;
    z-index: 1;
    max-height: 650px;
    min-height: 120px;
}
.ajusBol{
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}
.bolinhas{   
    display: none;
    position: absolute;   
    box-shadow: 0px 6px 6px #00000029;
    top:0px;
    z-index: 3;
    background: #fff;
}
.bolinhas  .a{
    display: flex;
    align-items: center; 
    padding: 7px;
    font-size: 14px;
    cursor: pointer;
}
.bolinhas  .a span{
    margin-left: 5px;
    font-weight: 600;
}
.bolinha{
    width: 20px;
    height: 20px;
    border-radius: 20px;
    background: #6D6D6B;
      
}
.ajusBol .triangulo{
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #707070;
    margin-left:5px;
    cursor: pointer;
    position: relative;
}
#notasCom{
    width: 100%;
    position: relative;
}
th{
    text-align: left;
}
table, th, td {  
  border-collapse: collapse;
  white-space: nowrap;
  font-size: 14px;
  padding:5px;
  text-align: left;
}
#notasCom  th{
    background-color: #009188;
    color:#fff;
}
#notasCom  tr:nth-child(odd){
    background: #0091881A;
}
#modalEmitir .modal-footer{
    display: none;
}
#modalEmitir {
    text-align:center;font-size: 18px;
}
</style>